import React, {  } from 'react';
import classNames from "classnames";

import Chip from '@material-ui/core/Chip';

import style  from './style.module.css';
import typ from "design-v2/globals/typography.module.css";
import colors from "design-v2/globals/colors/colors.module.css";
import {ITagChip} from './types';
import CloseIcon from '@material-ui/icons/Close';
import TagPanelIcon from './TagPanelIcon';

const TagChip = (props: ITagChip) => {
  const {
    testId,
    tag,
    handleDelete,
  } = props;

  return (
    <div className={style.tagChip}>
      <Chip
        data-testid={'test-id-chip-'+testId.toString()}
        className={classNames({
          // [style.riskyBackground]: tag.isRisky
        })}
        label={
          <div>
            <span className={classNames({
              [style.chipLabel]: true,
              [typ.typSize3]: true,
              [typ.typMed]: true,
            })}>{tag.name}</span>
          </div>
        }
        onDelete={handleDelete}
        icon={<div>
          <TagPanelIcon tag={tag} />
        </div>}
        deleteIcon={<CloseIcon className={colors.clrNbiMagenta} />}
      />
    </div>
  );
}
export default TagChip;
